import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { config as CONFIG } from "app/app.config";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { FormControl } from "@angular/forms";
import { Subscription,Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import { Filtro } from "app/main/apps/shared/interfaces/filtro.interface";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { FiltroOrdenesCompra } from 'app/main/apps/shared/interfaces/filtro-ordenescompra.interface';
import { MatChipInputEvent } from '@angular/material/chips';
import { ClienteDTO } from 'app/main/apps/shared/interfaces/cliente.interface';
import { MenuUsuarioService } from 'app/main/apps/shared/services/util/menu-usuario.service';


@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})
export class SearchboxComponent implements OnInit , OnDestroy{

  @Output()
  filtrarOrdenesCompra: EventEmitter<FiltroOrdenesCompra> = new EventEmitter();
  filtros: FiltroOrdenesCompra;

  @ViewChild("estadoInput") estadoInput: ElementRef<HTMLInputElement>;
  @ViewChild("clienteInput") clienteInput: ElementRef<HTMLInputElement>;
  @ViewChild("rutInput") rutInput: ElementRef<HTMLInputElement>;
  @ViewChild("nroOOCCInput") nroOOCCInput: ElementRef<HTMLInputElement>;
  @ViewChild("recepcionInput") recepcionInput: ElementRef<HTMLInputElement>;
  
  @Input() estados: Filtro[];
  @Input() clientes: ClienteDTO[];
  @Input() recepciones: Filtro[];
  subscripciones: Subscription;
 
  filteredClientes: Observable<ClienteDTO[]>;
  filteredEstados: Observable<any[]>;
  filteredRecepciones: Observable<any[]>;

  estadoCtrl = new FormControl();
  clienteCtrl = new FormControl();
  rutCtrl = new FormControl();
  nroOOCCCtrl = new FormControl();
  recepcionCtrl = new FormControl();


  config;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private _filtroSrvc: FiltrosService, public _menuUsuarioSrvc: MenuUsuarioService) { 
    this.config = CONFIG;
    this.filtros = this._filtroSrvc.getFiltro("filtrosOOCC");
    this.subscripciones = new Subscription();

    this.filteredClientes = this.clienteCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "nombre", this.clientes)
              : this.clientes.slice()
      )
    );

    this.filteredEstados = this.estadoCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "descripcion", this.estados)
              : this.estados.slice()
      )
    );

    this.filteredRecepciones = this.recepcionCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "descripcion", this.recepciones)
              : this.recepciones.slice()
      )
    );
  }


  ngOnDestroy(): void {
    this.limpiarTodosFiltros();
  }


  private _filter(
    value: string | any,
    columnaAFiltrar: string,
    listaDeValoresAfiltrar: any[]
  ): any[] {
    let filterValue: string;
    if (typeof value === "object") {
        filterValue = value[columnaAFiltrar].toLowerCase();
    } else {
        filterValue = value.toLowerCase();
    }

    return listaDeValoresAfiltrar.filter((item) =>
        item[columnaAFiltrar].toLowerCase().includes(filterValue)
    );
  }


  agregarFiltro(
    event: MatChipInputEvent,
    controller: any,
    filtroSeleccionado: string
  ) {
    const input = event.input;
    const value = event.value;
    if ((value || "").trim()) {
        this._filtroSrvc.setFiltro(
            "filtrosOOCC",
            filtroSeleccionado,
            value.trim(),
            value.trim()
        );
    }

    if (input) {
        input.value = "";
    }

    controller.setValue(null);
}


  seleccionarFiltro(
    event: MatAutocompleteSelectedEvent,
    columnaValor: string,
    columnaDescripcion: string,
    controller: any,
    input: string,
    filtroSeleccionado: string
) {

//console.log(event.option);

    const valor = event.option.value[columnaValor];
    const descripcion = event.option.value[columnaDescripcion];

    this._filtroSrvc.setFiltro(
        "filtrosOOCC",
        filtroSeleccionado,
        valor,
        descripcion
    );
    this[input].nativeElement.value = "";
    controller.setValue(null);
    this.filtros = this._filtroSrvc.getFiltro("filtrosOOCC");
}

limpiarTodosFiltros() {
  this._filtroSrvc.initFiltrosOOCC();
  this.filtros = this._filtroSrvc.getFiltro("filtrosOOCC");
  this.filtrar();
}

quitarFiltro(nombreFiltro: string) {
  this._filtroSrvc.resetFiltro("filtrosOOCC", nombreFiltro);
}


filtrar() {
  this.filtrarOrdenesCompra.emit(this.filtros);
}

ngOnInit(): void {
  this.subscripciones.add(
    this._filtroSrvc.filtrosOOCCLoaded$.subscribe((filtros) => {
        this.filtros = filtros;
    })
);
}

}
